import { ReactElement } from 'react';
import { sepFormat } from 'utilities';
import { controlCol } from 'styles/style.css';
import { RemoveButton } from 'components';
import type { ApplicationType, AppliedLink } from 'modules/applicator/types';
import { InvoiceWidget } from 'modules/invoicing/common/InvoiceWidget';
import { Table, Tbody, Td, Th, Thead, Tr } from '@ff-it/ui';

type AppliedListProps = {
  items: AppliedLink[];
  applicationType: ApplicationType;
  actionHandler?: (item: AppliedLink) => void;
};

export function AppliedList({ items, applicationType, actionHandler }: AppliedListProps): ReactElement {
  return (
    <Table data-testid="applied" variant="dark" striped>
      <Thead>
        <Tr>
          <Th>Applied to invoice</Th>
          <Th textAlign="right">Total amount</Th>
          <Th textAlign="right">Applied amount</Th>
          <Th className={controlCol}></Th>
        </Tr>
      </Thead>
      <Tbody>
        {items.map((item) => {
          const { destination, amount } = item;

          const totalAmount = destination[applicationType === 'advance' ? 'total' : 'sub_total'];

          return (
            <Tr key={destination.id}>
              <Td>
                <InvoiceWidget invoice={destination} link />
              </Td>
              <Td textAlign="right" valign="middle">
                {sepFormat(totalAmount)}
              </Td>
              <Td textAlign="right" valign="middle">
                {sepFormat(amount)}
              </Td>
              <Td valign="middle">
                {actionHandler && (
                  <RemoveButton testId={`applied-action-${destination.id}`} onClick={() => actionHandler(item)} />
                )}
              </Td>
            </Tr>
          );
        })}
      </Tbody>
    </Table>
  );
}
